var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { CollapsibleContext } from './CollapsibleContext';
import { CollapsibleListItem } from './CollapsibleListItem';
import { Collapsible } from '../../components/Collapsible/Collapsible';
export const CollapsibleList = (_a) => {
    var { children, className, el: Element = 'ul' } = _a, rest = __rest(_a, ["children", "className", "el"]);
    const ListClasses = classnames('CollapsibleList cursor-default', className);
    const context = React.useContext(CollapsibleContext);
    const withWrapper = (React.createElement(Element, Object.assign({ className: ListClasses, "data-anvil-component": "CollapsibleList" }, rest), children));
    if (context)
        return (React.createElement(Collapsible, { open: context.expanded, animate: context.animate, ref: context.collapsibleRef }, withWrapper));
    return withWrapper;
};
CollapsibleList.Item = CollapsibleListItem;
//# sourceMappingURL=CollapsibleList.js.map